import { formatCurrency } from "@/lib/currency";
import type { DisplayCurrency } from "@/hooks/finance/cash-flow/useCashFlow";

export function makeFormatValue(displayCurrency: DisplayCurrency) {
  return (val: number) => {
    if (val === 0) return "–";
    if (val < 0) {
      return `(${formatCurrency(Math.abs(val), displayCurrency)})`;
    }
    return formatCurrency(val, displayCurrency);
  };
}

export function formatPercent(val: number) {
  if (isNaN(val) || !isFinite(val)) return "0%";
  return `${(val * 100).toFixed(1)}%`;
}

export function RowSparkline({
  data,
  color,
}: {
  data: number[];
  color: string;
}) {
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;

  return (
    <div className="flex items-end h-full gap-0.5 pt-1">
      {data.slice(-7).map((v, i) => (
        <div
          key={i}
          className="w-1 rounded-t-[1px]"
          style={{
            height: `${Math.max(((v - min) / range) * 100, 10)}%`,
            backgroundColor: color,
            opacity: 0.5 + i * 0.08,
          }}
        />
      ))}
    </div>
  );
}